import {
  setIsLoading,
  setSuccess,
  setError,
  setInitialState
} from './address-list-slice';
import { getPremises } from 'api/premises';
import { getErrors } from 'api/client';

export const getAddressListThunk = (postcode, requestConfig) => async (
  dispatch
) => {
  try {
    dispatch(setInitialState());
    dispatch(setIsLoading());
    const result = await getPremises(postcode, requestConfig);

    dispatch(setSuccess(result));

    return Promise.resolve(result);
  } catch (e) {
    const errors = getErrors(e);
    errors && dispatch(setError(errors));

    return Promise.reject(errors);
  }
};
